import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Post from "../../components/Post/Post";

const Details = () => {
	return (
		<div>
			<Navbar></Navbar>
			<Post></Post>
		</div>
	);
};

export default Details;
